import * as Yup from 'yup'

// https://www.regexpal.com/1978
const phoneExp = RegExp(
  /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/g // eslint-disable-line
)

export const schema = Yup.object().shape(
  {
    gender: Yup.string().required('rolex.contactForm.errorGender'),
    firstName: Yup.string(),
    lastName: Yup.string().required('rolex.contactForm.errorLastName'),
    email: Yup.string().when('phone', phone => {
      if (!phone) {
        return Yup.string()
          .required('rolex.contactForm.errorEmail')
          .email('rolex.contactForm.errorEmail')
      } else {
        return Yup.string().email('rolex.contactForm.errorEmail')
      }
    }),
    countryCode: Yup.string(),
    phone: Yup.string().when('email', email => {
      if (!email) {
        return Yup.string()
          .matches(phoneExp, 'rolex.contactForm.errorPhone')
          .required('rolex.contactForm.errorPhone')
      } else {
        return Yup.string().matches(phoneExp, 'rolex.contactForm.errorPhone')
      }
    }),
    location: Yup.string(),
    store: Yup.string(),
    message: Yup.string(),
    agree: Yup.bool().oneOf([true], 'rolex.contactForm.errorPrivacy'),
    subscribe: Yup.boolean()
  },
  [['email', 'phone']]
)
